import { COLLECTION_NAME, getSubscription } from '.';
import { addDocument, updateDocument } from 'db/mutations';
import { updateReferrals } from 'services/users';
import { increment } from 'firebase/firestore';

export const createSubscription = async (preapprovalId, plans, user) => {
  try {
    const response = await getSubscription(preapprovalId);
    const status = response.status;

    if (status !== 'authorized') {
      return {
        status,
        message: 'Subscription not approved',
      };
    }

    const selectedPlan = plans.find(
      (plan) => plan._id === response.preapproval_plan_id
    );

    const subscription = await addDocument(COLLECTION_NAME, {
      ...response,
      payer_email: response.payer_email || user.email,
      user_id: user.uid,
    });

    await updateDocument('users', user.uid, {
      credits: increment(selectedPlan.monthlyCredits),
      subscriptionId: subscription.id,
    });

    updateReferrals(user.uid);

    return {
      message: 'Subscription created successfully',
      subscriptionId: subscription.id,
      status: 'success',
    };
  } catch (error) {
    console.error('Error fetching subscription:', error);
  }
};
